define('modules/common/filter/nl2br',[], function() {

 var nl2br= function(str, is_xhtml) {
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    };


	var Filter = function($filter) {

		return function(string) {
			if (string) {
                return nl2br(string);
            } else {
                return "";
            }    
        
        };

	};
	return ["$filter", Filter];
});




 
